'use strict';

angular.module('lmsApp')
    .factory('Bookshelf', function ($resource) {
        return $resource('api/bookshelfs/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    });
